import { render } from "./notification-count.vue?vue&type=template&id=030ff68d&ts=true"
import script from "./notification-count.vue?vue&type=script&lang=ts"
export * from "./notification-count.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__